

module.exports = __webpack_require__.stylable.create(
    "Calendar2775648868",
    {"classes":{"root":"Calendar2775648868__root","header":"Calendar2775648868__header","month":"BaseCalendar2152870650__month","day":"BaseCalendar2152870650__day"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    12,
    "Calendar2775648868",
    null
);
